<template>

	<header class="nav-bar-header">

		<nav class="nav-bar-nav">

			<a
				v-for="(link, index) in menuItems"
				:key="index"
				:href="link.href"
			>
				<Icon :icon="link.icon" />
				{{ " " + link.name }}
			</a>

		</nav>

		<div style="padding: 1rem;">

			<button class="hamburger-menu" @click="toggleMenu">

				<span></span>
				<span></span>
				<span></span>

			</button>

		</div>

		<div v-if="isMenuOpen" class="mobile-menu" aria-label="Open navigation menu">

			<a
				v-for="(link, index) in menuItems"
				:key="index"
				:href="link.href"
			>
				<Icon :icon="link.icon" />
				{{ " " + link.name }}
			</a>

		</div>

	</header>

</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Icon from "./Icon/Icon.vue";

export default defineComponent({
	name: "NavBar",

	components: {
		Icon
	},

	setup() {

		const isMenuOpen = ref(false);

		const menuItems = [
			{
				name: "My Work",
				href: "/",
				icon: "work"
			},
			{
				name: "CV",
				href: "/src/CV-Kylian-Dekker.pdf",
				icon: "cv"
			},
			{
				name: "About Me",
				href: "/about",
				icon: "user"
			},
			{
				name: "Mail Me",
				href: "mailto:kyliandekker2000@gmail.com",
				icon: "mail"
			},
			{
				name: "LinkedIn",
				href: "https://www.linkedin.com/in/kyliandekker",
				icon: "linkedin"
			},
			{
				name: "GitHub",
				href: "https://github.com/kyliandekker",
				icon: "github"
			}
		];

		function toggleMenu(): void
		{
			isMenuOpen.value = !isMenuOpen.value;
		}

		return {
			isMenuOpen,
			menuItems,
			toggleMenu
		};
	}
});
</script>

<style lang="scss" scoped>

@import url("/public/src/css/navbar.scss");

</style>